import './sim/modules/load.ts';
import * as Phaser from 'phaser';
import { createGameConfig } from './game/config.ts';
import { installEscapeRouter } from './ui/pause/escape.ts';
import { mountOverlay } from './ui/overlay.tsx';
import './styles/global.css';

mountOverlay();
installEscapeRouter();
new Phaser.Game(createGameConfig());
